import { Button, Result } from 'antd';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { withTranslation, type WithTranslation } from 'react-i18next';

interface Props extends WithTranslation {
  readonly children: ReactNode;
}

interface State {
  readonly hasError: boolean;
}

class ErrorBoundaryInner extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    const { t, children } = this.props;
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title={t('errors.boundaryTitle')}
          extra={
            <Button onClick={() => window.location.reload()}>
              {t('errors.boundaryAction')}
            </Button>
          }
        />
      );
    }
    return children;
  }
}

const ErrorBoundary = withTranslation()(ErrorBoundaryInner);

export default ErrorBoundary;
